"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var _ = require("lodash");
var TargetIncomeSolverResults = (function () {
    function TargetIncomeSolverResults() {
    }
    return TargetIncomeSolverResults;
}());
exports.TargetIncomeSolverResults = TargetIncomeSolverResults;
var TargetIncomeSolver = (function () {
    function TargetIncomeSolver() {
    }
    TargetIncomeSolver.prototype.init = function (engine, inputs, debugMode) {
        if (debugMode === void 0) { debugMode = false; }
        this.engine = engine;
        this.inputs = inputs;
        this.debugMode = debugMode;
    };
    TargetIncomeSolver.prototype.solve = function (inputs) {
        if (inputs === void 0) { inputs = false; }
        if (inputs) {
            this.inputs = inputs;
        }
        var ScenarioCount = this.inputs.ScenarioCount ? this.inputs.ScenarioCount : 10;
        var SearchTolerance = this.inputs.SearchTolerance ? this.inputs.SearchTolerance : 100;
        var MaximumIterations = this.inputs.MaximumIterations ? this.inputs.MaximumIterations : 10;
        var RunOutAge = this.inputs.RunOutAge ? this.inputs.RunOutAge : 92;
        var IncludePartner = this.inputs.IncludePartner;
        var RetirementAge = this.inputs.RetirementAge;
        var AgeNow = this.inputs.AgeNow;
        var TargetIncomeScenarios = Array.from({ length: ScenarioCount + 1 }, function () { return 0; });
        var BalanceAtRunOutAge = Array.from({ length: ScenarioCount + 1 }, function () { return 0; });
        var IncomeInFinalYear = Array.from({ length: ScenarioCount + 1 }, function () { return 0; });
        var RunOutAgeRow = RunOutAge - AgeNow;
        var RetirementAgeRow = RetirementAge - AgeNow;
        var ScenarioStep;
        var MaximumTargetIncomeToTest;
        var IndexFirstTargetIncomeScenarioWithRemainingFunds = 0;
        var FoundFirstTargetIncomeScenarioWithRemainingFunds = false;
        var FoundAcceptableScenario = false;
        var MinimumTargetIncomeToTest = 0;
        var TargetIncome = 0;
        var iterationcount = 1;
        var subjectResult;
        var partnerResult;
        var output = null;
        output = this.engine.runSync(this.inputs);
        if (this.debugMode) {
            console.log("TargetIncomeSolver -> First Run -> ", "RetirementAgeRow:", RetirementAgeRow, "age[" + RetirementAgeRow + "]:", output.engineResults.subjectOutput.age[RetirementAgeRow], "Inputs:", _.cloneDeep(this.inputs), "Output:", _.cloneDeep(output));
        }
        subjectResult = output.engineResults.subjectOutput;
        partnerResult = output.engineResults.partnerOutput;
        if (IncludePartner) {
            MaximumTargetIncomeToTest =
                subjectResult.deflatedAccumulationAssetsInYear[RetirementAgeRow] +
                    subjectResult.deflatedPensionAssetsInYear[RetirementAgeRow] +
                    partnerResult.deflatedAccumulationAssetsInYear[RetirementAgeRow] +
                    partnerResult.deflatedPensionAssetsInYear[RetirementAgeRow] +
                    subjectResult.deflatedOtherIncome[RetirementAgeRow];
        }
        else {
            MaximumTargetIncomeToTest =
                subjectResult.deflatedAccumulationAssetsInYear[RetirementAgeRow] +
                    subjectResult.deflatedPensionAssetsInYear[RetirementAgeRow] +
                    subjectResult.deflatedOtherIncome[RetirementAgeRow];
        }
        MaximumTargetIncomeToTest = Math.max(MaximumTargetIncomeToTest, 100000);
        if (this.debugMode) {
            console.log("TargetIncomeSolver -> IncludePartner", IncludePartner);
            console.log("TargetIncomeSolver -> MaximumTargetIncomeToTest", MaximumTargetIncomeToTest);
        }
        while (!FoundAcceptableScenario && iterationcount <= MaximumIterations) {
            ScenarioStep = (MaximumTargetIncomeToTest - MinimumTargetIncomeToTest) / (ScenarioCount - 1);
            for (var i_1 = 1; i_1 <= ScenarioCount; i_1++) {
                if (this.debugMode) {
                    console.log("For loop -> i =", i_1);
                }
                TargetIncomeScenarios[i_1] = MaximumTargetIncomeToTest - (ScenarioStep * (i_1 - 1));
            }
            if (this.debugMode) {
                console.log("TargetIncomeSolver -> MaximumTargetIncomeToTest", MaximumTargetIncomeToTest);
                console.log("TargetIncomeSolver -> MinimumTargetIncomeToTest", MinimumTargetIncomeToTest);
                console.log("TargetIncomeSolver -> ScenarioStep", ScenarioStep);
                console.log("TargetIncomeSolver -> TargetIncomeScenarios", _.cloneDeep(TargetIncomeScenarios));
            }
            for (var i_2 = 1; i_2 <= ScenarioCount; i_2++) {
                if (this.debugMode) {
                    console.log("For loop -> i =", i_2);
                }
                this.inputs.TargetIncome = TargetIncomeScenarios[i_2];
                output = this.engine.runSync(this.inputs);
                if (this.debugMode) {
                    console.log("TargetIncomeSolver -> For Loop -> ", "Inputs", _.cloneDeep(this.inputs), "Output", _.cloneDeep(output));
                }
                subjectResult = output.engineResults.subjectOutput;
                partnerResult = output.engineResults.partnerOutput;
                if (IncludePartner) {
                    BalanceAtRunOutAge[i_2] =
                        subjectResult.deflatedAccumulationAssetsInYear[RunOutAgeRow] +
                            subjectResult.deflatedPensionAssetsInYear[RunOutAgeRow] +
                            partnerResult.deflatedAccumulationAssetsInYear[RunOutAgeRow] +
                            partnerResult.deflatedPensionAssetsInYear[RunOutAgeRow];
                    IncomeInFinalYear[i_2] =
                        subjectResult.deflatedAgePension[RunOutAgeRow - 1] +
                            subjectResult.deflatedPensionDrawingsInYear[RunOutAgeRow - 1] +
                            partnerResult.deflatedAgePension[RunOutAgeRow - 1] +
                            partnerResult.deflatedPensionDrawingsInYear[RunOutAgeRow - 1];
                }
                else {
                    BalanceAtRunOutAge[i_2] =
                        subjectResult.deflatedAccumulationAssetsInYear[RunOutAgeRow] +
                            subjectResult.deflatedPensionAssetsInYear[RunOutAgeRow];
                    IncomeInFinalYear[i_2] =
                        subjectResult.deflatedAgePension[RunOutAgeRow - 1] +
                            subjectResult.deflatedPensionDrawingsInYear[RunOutAgeRow - 1];
                    if (this.debugMode) {
                        try {
                            console.warn("i", i_2, "BalanceAtRunOutAge", subjectResult.deflatedAccumulationAssetsInYear[RunOutAgeRow] +
                                subjectResult.deflatedPensionAssetsInYear[RunOutAgeRow], "IncomeInFinalYear", subjectResult.deflatedAgePension[RunOutAgeRow - 1] +
                                subjectResult.deflatedPensionDrawingsInYear[RunOutAgeRow - 1], "+ / - lines for comparison", "BalanceAtRunOutAge", subjectResult.deflatedAccumulationAssetsInYear[RunOutAgeRow + 1] +
                                subjectResult.deflatedPensionAssetsInYear[RunOutAgeRow + 1], "/", "BalanceAtRunOutAge", subjectResult.deflatedAccumulationAssetsInYear[RunOutAgeRow - 1] +
                                subjectResult.deflatedPensionAssetsInYear[RunOutAgeRow - 1], "---", "IncomeInFinalYear", subjectResult.deflatedAgePension[RunOutAgeRow] +
                                subjectResult.deflatedPensionDrawingsInYear[RunOutAgeRow], "/", "IncomeInFinalYear", subjectResult.deflatedAgePension[RunOutAgeRow - 2] +
                                subjectResult.deflatedPensionDrawingsInYear[RunOutAgeRow - 2]);
                        }
                        catch (e) {
                            console.log(e);
                        }
                    }
                }
            }
            if (this.debugMode) {
                console.log("TargetIncomeSolver -> ", "RunOutAgeRow", RunOutAgeRow, "|", "BalanceAtRunOutAge", _.cloneDeep(BalanceAtRunOutAge), "IncomeInFinalYear", _.cloneDeep(IncomeInFinalYear));
            }
            IndexFirstTargetIncomeScenarioWithRemainingFunds = 0;
            FoundFirstTargetIncomeScenarioWithRemainingFunds = false;
            for (var i = 1; i <= ScenarioCount; i++) {
                if (this.debugMode) {
                    console.log("For loop -> i =", i);
                }
                if ((BalanceAtRunOutAge[i] > 0) && (!FoundFirstTargetIncomeScenarioWithRemainingFunds)) {
                    IndexFirstTargetIncomeScenarioWithRemainingFunds = i;
                    FoundFirstTargetIncomeScenarioWithRemainingFunds = true;
                }
            }
            if (this.debugMode && FoundFirstTargetIncomeScenarioWithRemainingFunds) {
                console.log("TargetIncomeSolver -> ", "IndexFirstTargetIncomeScenarioWithRemainingFunds / i", IndexFirstTargetIncomeScenarioWithRemainingFunds, "FoundFirstTargetIncomeScenarioWithRemainingFunds", FoundFirstTargetIncomeScenarioWithRemainingFunds);
            }
            if ((IndexFirstTargetIncomeScenarioWithRemainingFunds == 1) || ((BalanceAtRunOutAge[IndexFirstTargetIncomeScenarioWithRemainingFunds] < SearchTolerance) &&
                ((TargetIncome - IncomeInFinalYear[IndexFirstTargetIncomeScenarioWithRemainingFunds]) < SearchTolerance))) {
                FoundAcceptableScenario = true;
            }
            else {
                MinimumTargetIncomeToTest = TargetIncomeScenarios[IndexFirstTargetIncomeScenarioWithRemainingFunds];
                MaximumTargetIncomeToTest = TargetIncomeScenarios[IndexFirstTargetIncomeScenarioWithRemainingFunds - 1];
            }
            if (this.debugMode) {
                console.log("TargetIncomeSolver -> ", "FoundAcceptableScenario", FoundAcceptableScenario, "RunOutAge", RunOutAge, "|", "MinimumTargetIncomeToTest", MinimumTargetIncomeToTest, "MaximumTargetIncomeToTest", MaximumTargetIncomeToTest, "|", "iterationcount", iterationcount);
            }
            iterationcount++;
        }
        if (FoundAcceptableScenario) {
            this.inputs.TargetIncome = TargetIncomeScenarios[IndexFirstTargetIncomeScenarioWithRemainingFunds];
        }
        output = this.engine.runSync(this.inputs);
        return {
            foundAcceptableScenario: FoundAcceptableScenario,
            targetIncome: this.inputs.TargetIncome,
            output: output
        };
    };
    TargetIncomeSolver.prototype.solveAsync = function (inputs) {
        if (inputs === void 0) { inputs = false; }
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2, Promise.resolve(this.solve(inputs))];
            });
        });
    };
    return TargetIncomeSolver;
}());
exports.TargetIncomeSolver = TargetIncomeSolver;
//# sourceMappingURL=TargetIncomeSolver.js.map